export default {
  altText: "in top targets widget"
};
